var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input-text',{attrs:{"label":_vm.label || _vm.$t('inputs.email.label'),"name":_vm.$t('inputs.email.label'),"placeholder":_vm.$t('inputs.email.placeholder'),"type":'email',"errors":_vm.errors,"value":_vm.value,"v-model":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }